/**
 * FormField Component
 * 
 * Wrapper component for form inputs with label, error message, and hint text.
 * Provides consistent styling across all forms.
 */

import React from 'react';

export interface FormFieldProps {
  /** Field label */
  label: string;
  /** Whether the field is required */
  required?: boolean;
  /** Error message to display */
  error?: string;
  /** Hint text below the input */
  hint?: string;
  /** The form input element */
  children: React.ReactNode;
  /** Additional CSS classes for the wrapper */
  className?: string;
}

export function FormField({
  label,
  required = false,
  error,
  hint,
  children,
  className = '',
}: FormFieldProps) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}{required && ' *'}
      </label>
      {children}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1 text-xs text-gray-500">{hint}</p>
      )}
    </div>
  );
}
